$.fn.ajaxInvalidFeedback = function(options) {
	if (typeof options === 'object') {
		return this.each(function() {
			createInvalidFeedback($(this), options);
		});
	}
	if (options === 'destroy') {
		return this.each(function() {
			destroyInvalidFeedback($(this));
		});
	}
	return this;
};

/*
	Miejsce, po którym wstawiamy komunikat.

	Pola z bąbelkiem „?" siedzą w `.form-hint-wrap` razem z przyciskiem, a bąbelek jest
	w tej obudowie wyśrodkowany w pionie (`top: 50%`). Komunikat wstawiony DO ŚRODKA
	rozciągał ją w dół i przy błędzie na dwie linie kółko zjeżdżało pod pole. Dlatego
	komunikat ląduje za całą obudową — bootstrapowy `.validation-group ~ .invalid-feedback`
	z components/form.scss jest właśnie na ten układ.

	Zgody (`.form-check`) też potrzebują własnego zakotwiczenia: `.form-check` jest
	`display: flex`, więc komunikat wstawiony obok inputa stawał się kolumną między
	kółkiem a treścią zgody. Za całym `.form-check` ląduje pod zgodą, na pełną szerokość
	— tak jak statyczny `invalid_feedback` z templates/form_theme.html.twig.
*/
function feedbackAnchor($field) {
	const $wrap = $field.closest('.form-hint-wrap');
	if ($wrap.length) {
		return $wrap;
	}

	const $check = $field.closest('.form-check');

	return $check.length ? $check : $field;
}

function createInvalidFeedback($field, options) {
	const errorHtml = `<div class='invalid-feedback invalid-feedback-ajax d-block'>${options.error}</div>`;
	$field.addClass('has-invalid-feedback-ajax');
	feedbackAnchor($field).after(errorHtml);
	attachFeedbackCleanupHandlers($field);
}

function destroyInvalidFeedback($field) {
	const data = $field.data('ajaxInvalidFeedback');
	if (!data) {
		return;
	}
	
	$field.off('change input', data.cleanup);
	$($field[0].form).off('submit reset', data.cleanup);
	$field.removeClass('has-invalid-feedback-ajax');
	feedbackAnchor($field).siblings('.invalid-feedback-ajax').remove();
	$field.data('ajaxInvalidFeedback', null);
}

function attachFeedbackCleanupHandlers($field) {
	const cleanup = () => $field.ajaxInvalidFeedback('destroy');
	$field.on('change input', cleanup);
	$($field[0].form).on('submit reset', cleanup);
	$field.data('ajaxInvalidFeedback', { cleanup });
}